export default "__VITE_ASSET__BKPy5O4Q__"